exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading[data-v-61bc60d8] {\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 3rem;\n\tfont-family: 'Seek Regular';\n}\n", ""]);

// exports
